module.exports = __webpack_public_path__ + "icon-dnc.f22a4be711a1953eb8a5.svg";